import React, { useState, useEffect } from "react";
import {Input, Col, Row, Form, Checkbox, notification, Select, Button, Tooltip} from 'antd';
import {PlusOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive'
import RequestHandler from "../../util/RequestHandler";

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const TenantPaymentAccountAddForm = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [bankDropdown, setbankDropdown] = useState([]);
  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [bankId, setbankId] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [iban, setIban] = useState("");

  const [form] = Form.useForm();

  const [isForeignCurrencySupported, setIsForeignCurrencySupported] = useState(false);

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });

  const [isUseAccountTransaction, setIsUseAccountTransaction] = useState(false);

  const [accounts, setAccounts] = useState([]);

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency?$select=id,code,name`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };


  const onChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(response => {
      setbankBranchDropdown(response);
      setbankId(value)
    });
  }
  const onChangeIban = (value) => {
    setIban(value.target.value);
  }
  const onChangeAccountNumber = (value) => {
    setAccountNumber(value.target.value);
  }

  useEffect(() => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${props.bankId}`).then(response => {
      setbankBranchDropdown(response);
    });

    RequestHandler.get(`/Bank`).then(response => {
       setbankDropdown(response.value.filter(x => x.isTosSupport === true));
    });

    RequestHandler.get(`/tenantModule?$filter=moduleId eq 1`).then(
      (response) => {
        if (response.value.length > 0) {

          RequestHandler.get(
            `/TenantAccount?$count=true&filter=bankId eq ${props.bankId}&select=iban,accountNumber,branchCode,branchName`
          ).then((response) => {
            if(response.value) {
              setAccounts(response.value);
            }
          });

          setIsUseAccountTransaction(true);
        }
      }
    );


  }, [setbankDropdown]);

  useEffect(() => {

    const bank = bankDropdown.filter(x => x.id == props.bankId);

    if(bank.length > 0) {
      setIsForeignCurrencySupported(bank[0].isTosForeignCurrencySupported);
      getCurrencies();
    }


  }, [bankDropdown])

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Ekleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const onFinish = values => {
    RequestHandler.post(`/TenantPaymentAccount`, {
      bankId: props.bankId,
      name: values.Name,
      iban: values.Iban,
      bankBranchId: values.BankBranchId,
      accountNumber: values.AccountNumber,
      isDefault: values.IsDefault === null ? false : values.IsDefault,
      currencyId: isForeignCurrencySupported ? values.currencyId : 1
    }, false, { rawResponse: true }).then(res => {
      if (res.status === 200) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          window.location.reload();
        }.bind(this), 2000);
      }else{
        setLoading(false)
        }
    });
  };
  const onFinishFailed = () => setLoading(false);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const selectAccount = (value, el) => {
    const branch = bankBranchDropdown.filter(x => x.code === el.branchCode);

    if(branch.length > 0) {
      form.setFieldsValue({"BankBranchId": branch[0].id})
    }
    form.setFieldsValue({"Iban": value, "AccountNumber": el.accountNumber });


  }

  const FormItemLabelWithTooltip = ({ label, tooltip }) => {
    return (
      <>
        {label}{" "}
        <Tooltip title={
          <span>
            {tooltip?.split('*').filter(part => part.trim() !== '').map((line, index) => (
              <div key={index}> * {line}</div>
            ))}
          </span>
        } overlayStyle={{ maxWidth: "450px" }}>
          <QuestionCircleOutlined
            className="gx-text-blue"
            style={{ marginLeft: 5,marginRight:3, fontSize: "120%" }}
          />
        </Tooltip>
      </>
    );
  };

  const { Option } = Select;

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        fields={[
          { name: "BankId", value: props.bankId }
        ]}
      >
        <Row>
          {isDesktopOrLaptop && <>
            <Col span={24}>

              <Form.Item
                label="Hesap Adı"
                name="Name"
                onChange={onChangeAccountNumber}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Banka"
                name="BankId"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen banka alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  disabled
                  placeholder="Seçiniz."
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankDropdown.map(item => (
                    item.name === "KASA HESABI" ? "" :
                      <Option key={item.id} >{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              {isUseAccountTransaction ? <>
                <Form.Item
                  label="Hesaplar"
                  name="TenantAccount"

                >
                  <Select
                    showSearch
                    onChange={selectAccount}
                    placeholder="Seçiniz"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {accounts.map(item => (
                      <Option key={item.iban} accountNumber={item.accountNumber} branchCode={item.branchCode} branchName={item.branchName}>{item.iban} - {item.accountNumber}</Option>
                    ))}
                  </Select>
                </Form.Item>
                </> : <></> }


              <Form.Item
                label="IBAN"
                name="Iban"
                onChange={onChangeIban}
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen Iban alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input type="text" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} defaultValue="TR" onFocus={(event) => { event.target.select() }} maxLength="26" />
              </Form.Item>

              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen banka şubesini seçiniz.',
                    },
                  ]}

              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdown.map(item => (
                    <Option key={item.id} value={item.id} >{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
                onChange={onChangeAccountNumber}
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen hesap numarası alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input maxLength="17" onInput={maxLengthCheck} />
              </Form.Item>

              {isForeignCurrencySupported ? <>
                  <Form.Item
                  name="currencyId"
                  label="Para Birimi"
                  initialValue={1}
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    placeholder="Seçiniz"
                    loading={currencySelect.loading}
                  >
                    {currencySelect.data.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {`${item.code} (${item.name})`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>:<></> }


              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Geçerli Hesap"
                    tooltip="Yalnızca 1 adet hesap geçerli olabilir, seçtiğinizde ödeme ekranında default seçili gelmesini sağlar."
                  />
                }
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>

            </Col>

            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={3}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Ekle
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}></Col>
          </>}
          {isTabletOrMobileDevice && <>
            <Col span={24}>
              <Form.Item
                label="Hesap Adı"
                name="Name"
                onChange={onChangeAccountNumber}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Banka"
                name="BankId"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen banka alanını boş bırakmayın.',
                  },
                ]}
              >
                <Select
                  showSearch
                  disabled
                  placeholder="Seçiniz."
                  optionFilterProp="children"
                  onChange={onChange}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankDropdown.map(item => (
                    item.name === "KASA HESABI" ? "" :
                      <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="IBAN"
                name="Iban"
                onChange={onChangeIban}
                rules={
                  [
                    {
                      required: true,
                      message: 'Lütfen Iban alanını boş bırakmayın.',
                    },
                  ]}
              >
                <Input type="text" defaultValue="TR" maxLength="26" />
              </Form.Item>

              <Form.Item
                label="Banka Şubesi"
                name="BankBranchId"
              >
                <Select
                  showSearch
                  placeholder="Seçiniz"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                >
                  {bankBranchDropdown.map(item => (
                    <Option key={item.id}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Hesap Numarası"
                name="AccountNumber"
                onChange={onChangeAccountNumber}
              >
                <Input maxLength="17" onInput={maxLengthCheck} />
              </Form.Item>

              {isForeignCurrencySupported ? <>
                <Form.Item
                  name="currencyId"
                  label="Para Birimi"
                  initialValue={1}
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    placeholder="Seçiniz"
                    loading={currencySelect.loading}
                  >
                    {currencySelect.data.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {`${item.code} (${item.name})`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>:<></> }

              <Form.Item
                label="Geçerli Hesap"
                name="IsDefault"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>

            </Col>
            <Col span={12}></Col>

            <Col span={6}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Ekle
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </>}
        </Row>
      </Form>
    </div>
  )
}
export default TenantPaymentAccountAddForm
